import { TrackingPageModel } from '../tracking-page.model';
import {
  getAppImage,
  getAsset,
  getFontConfig,
  getFooterItems,
  getLogo,
  getSocialIcons,
  getLanguageMenu,
  white,
  getProductItems
} from './helpers';

export const nova: TrackingPageModel = {
  languageMenu: getLanguageMenu('Roboto', '#858585ff'),
  searchPageInput: {
    backgroundColor: white,
    shadow: 'none',
    borderColor: '#ced4da',
    borderWidth: 1,
    borderRadius: 4,
    ...getFontConfig('Roboto', '#6d788c')
  },
  searchPageTitle: {
    fontSize: 18,
    ...getFontConfig('Roboto', '#858585ff')
  },
  background: {
    color: '#f3f3f3ff',
    useBackgroundImage: false,
    imageUrl: getAppImage('/assets/img/tracking-page/Img_map_white.png'),
    backgroundMode: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  },
  card: {
    linksColor: '#9c756fff',
    linksUnderline: false,
    backgroundColor: '#f3f3f3ff',
    headerBackground: '#f3f3f3ff',
    footerBackground: '#f3f3f3ff',
    borderColor: '#85858533',
    borderRadius: 0,
    borderWidth: 1,
    shadow: 'none',
    trackingNumberField: 'trackingNumber',
    ...getFontConfig('Roboto', '#858585ff')
  },
  orderCard: {
    borderRadius: 0,
    borderWidth: 1,
    borderColor: '#85858533',
    backgroundColor: '#ffffffff',
    shadow: 'none',
    footerBackground: '#f3f3f3ff',
    headerBackground: '#f3f3f3ff',
    linksColor: '#9c756fff',
    linksUnderline: false,
    ...getFontConfig('Roboto', '#858585ff')
  },
  orderNumber: {
    alignment: 'center',
    fontSize: 19,
    ...getFontConfig('Noto Sans JP', '#323232ff')
  },
  orderStatus: {
    alignment: 'center',
    fontSize: 18,
    ...getFontConfig('Playfair Display', '#433131ff')
  },
  orderLastUpdated: {
    alignment: 'center',
    fontSize: 11,
    ...getFontConfig('Noto Sans JP', '#858585ff')
  },
  notYetShippedItemsTitle: {
    alignment: 'center',
    fontSize: 11,
    ...getFontConfig('Roboto', '#858585ff')
  },
  orderStatusOn: true,
  orderNumberOn: true,
  orderLastUpdatedOn: true,
  orderItemsFrame: {
    on: true,
    shadow: 'none',
    borderColor: '#ede8e8ff',
    borderRadius: 0,
    borderWidth: 1,
    backgroundColor: '#ffffff',
    button: {
      on: true,
      backgroundColor: '#ffffff',
      borderColor: '#9c756fff',
      borderRadius: 0,
      borderWidth: 1,
      shadow: 'none',
      ...getFontConfig('Lato', '#9c756fff')
    },
    itemsLimit: 4,
    scroll: false,
    itemCard: {
      backgroundColor: '#ffffffff',
      borderColor: '#85858533',
      borderRadius: 0,
      borderWidth: 1,
      shadow: 'none',
      title: {
        alignment: 'left',
        fontSize: 18,
        ...getFontConfig('Playfair Display', '#3f2f2fff')
      },
      info: {
        alignment: 'left',
        fontSize: 11,
        ...getFontConfig('Roboto', '#858585ff')
      },
      showAttributes: false
    }
  },
  searchButton: {
    on: true,
    backgroundColor: '#ffffff00',
    borderColor: '#9c756fff',
    borderRadius: 0,
    borderWidth: 1,
    shadow: 'none',
    ...getFontConfig('Lato', '#9c756fff')
  },
  detailsButton: {
    on: null,
    backgroundColor: '#9c756fff',
    borderColor: '#00ccff00',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Lato', white)
  },
  trackButton: {
    on: null,
    backgroundColor: '#9c756fff',
    borderColor: '#ee7227',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Lato', white)
  },
  pageScroll: {
    scrollColor: '#00000033',
    borderRadius: 4,
    backgroundColor: '#ffffff00'
  },
  scripts: {
    head: null,
    body: null
  },
  logo: getLogo(getAsset('/images/themes/5c98d96064cf6_logo-1-360x.png')),
  socialIcons: getSocialIcons('#9c756fff'),
  sidebar: {
    parcelIcon: 'icon-parcel',
    groupIcon: 'icon-track_number',
    backgroundColor: '#f3f3f3ff',
    borderColor: '#85858533',
    borderRadius: 0,
    borderWidth: 1,
    sidebarField: 'orderNumbers',
    shadow: 'none',
    ...getFontConfig('Roboto', '#858585ff')
  },
  footer: {
    linksColor: '#9c756fff',
    linksUnderline: false,
    backgroundColor: '#f3f3f3ff',
    ...getFooterItems(),
    ...getFontConfig('Roboto', '#858585ff')
  },
  header: {
    backgroundColor: white
  },
  faviconUrl: '/assets/favicon/favicon-32x32.png',
  defaultThemeId: 'nova',
  sidebarProductsFeed: {
    on: true,
    backgroundColor: '#ffffffff',
    borderColor: '#85858533',
    borderRadius: 0,
    borderWidth: 1,
    shadow: 'none',
    card: {
      backgroundColor: '#ffffffff',
      borderColor: '#85858533',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      button: {
        on: null,
        backgroundColor: '#9c756fff',
        borderColor: '#00ccff00',
        borderRadius: 0,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Lato', white)
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 14,
        ...getFontConfig('Playfair Display', '#3d2727ff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Roboto', '#858585ff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 18,
        ...getFontConfig('Poppins', '#14a224ff')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('sidebar'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#9c756fff',
      arrowSize: 24
    }
  },
  mainProductsFeed: {
    on: true,
    backgroundColor: '#ffffffff',
    borderColor: '#85858533',
    borderRadius: 0,
    borderWidth: 1,
    shadow: 'none',
    card: {
      backgroundColor: '#ffffffff',
      borderColor: '#85858533',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      button: {
        on: null,
        backgroundColor: '#9c756fff',
        borderColor: '#00ccff00',
        borderRadius: 0,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Lato', white)
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Playfair Display', '#352323ff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Roboto', '#858585ff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 17,
        ...getFontConfig('Poppins', '#097b28ff')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('main'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#9c756fff',
      arrowSize: 24
    }
  },
  seoTitle: ''
};
